<div class="insights-library">
  <app-topbar [brand]="false">
    <div app-topbar-title>
      <i class="fas fa-analytics c-orange"></i>
      <span>Library</span>
    </div>

    <div class="w-100p">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <div [hidden]="inViewMode">
            <trg-checkbox appearance="circle" size="large" class="mr-16"
                          [readonly]="busy"
                          [value]="page === 'insights'"
                          (valueChange)="setPage('insights')">Visuals ({{visuals.length}})</trg-checkbox>

            <trg-checkbox appearance="circle" size="large" class="mr-16"
                          [readonly]="busy"
                          [value]="page === 'dashboards'"
                          (valueChange)="setPage('dashboards')">Dashboards ({{dashboards.length}})</trg-checkbox>
          </div>
          <div [hidden]="!inViewMode" class="d-flex align-items-center">
            <button trgButton color="blue-outline" class="h-30 lh-30 min-w-100 text-left" (click)="turnViewModeOff()">
              <i class="far fa-chevron-left i-12 mr-8"></i>
              <span>Back</span>
            </button>

            <button trgButton color="primary" class="h-30 lh-30 min-w-100 text-left ml-15 px-12" 
                    [disabled]="busy || !canCopyViewedItem" (click)="copyViewedItem()">
              <i class="fal fa-copy i-12 mr-6"></i>
              <span>Copy</span>
            </button>

            <button *ngIf="canExportToPDFViewedItem"
                    trgButton color="primary" class="h-30 lh-30 min-w-100 text-left ml-15 px-12" 
                    [disabled]="busy" (click)="exportToPDFViewedItem()">
              <i class="far fa-file-pdf i-12 mr-4"></i>
              <span>Export to PDF</span>
            </button>

            <div class="topbar__vertical-line h-34 lh-34"></div>
            
            <div class="d-inline-flex align-items-center">
              <span class="fs-14 c-text-color-dark mr-8">Name:</span>
              <span class="fs-18 c-blue bold">{{viewedItemName}}</span>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div [hidden]="inViewMode" class="d-flex align-items-center">
            <button trgButton color="primary" class="trg-toggle h-30 lh-30" [class.in]="starredOnly" (click)="toggleStarredOnly()" [disabled]="busy">
              <i class="fas fa-star i-10 fs-8 i-circle mr-4"></i>
              <span>Starred</span>
            </button>

            <div class="topbar__vertical-line h-34 lh-34"></div>

            <div>
              <span class="mr-8">Find:</span>
              <input class="trg-outline h-34 lh-34 mr-4" type="text" placeholder="Enter Text" [formControl]="filterTextControl">
            </div>

            <div class="topbar__vertical-line h-34 lh-34"></div>
          </div>

          <button trgButton class="dialog-close-btn" (click)="close()">
            <i class="fas fa-times i-15 p-relative ot-1"></i>
          </button>
        </div>
      </div>
    </div>
  </app-topbar>

  <div class="insights-library__contents pt-20 px-15 pb-24 h-100p w-100p overflow-x-hidden border-box">
    <ng-container *ngIf="loading()">
      <app-spinner></app-spinner>
    </ng-container>
    <ng-container *ngIf="!loading()">
      <div [hidden]="inViewMode">
        <div [hidden]="page !== 'insights'" class="h-100p">
          <ng-container *ngIf="loadingVisuals">
            <app-spinner></app-spinner>
          </ng-container>
          <ng-container *ngIf="!loadingVisuals">
            <app-insights-library__insights
              [user]="user"
              [busy]="busy"
              
              [appSettings]="appSettings"

              (categorySelected)="visualCategorySelected.emit($event)"
              (itemSelected)="visualItemSelected.emit($event)"

              (favourite)="favouriteVisual.emit($event)"
              (addToHome)="addToHomeVisual.emit($event)"
              (view)="viewVisual.emit($event)"
              (copyVisual)="copyVisual.emit($event)">
            </app-insights-library__insights>
          </ng-container>
        </div>

        <div [hidden]="page !== 'dashboards'" class="h-100p">
          <ng-container *ngIf="loadingDashboards">
            <app-spinner></app-spinner>
          </ng-container>
          <ng-container *ngIf="!loadingDashboards">
            <app-insights-library__dashboards
              [user]="user"
              [busy]="busy"

              (categorySelected)="dashboardCategorySelected.emit($event)"
              (itemSelected)="dashboardItemSelected.emit($event)"

              (favourite)="favouriteDashboard.emit($event)"
              (view)="viewDashboard.emit($event)"
              (copyDashboard)="copyDashboard.emit($event)"
              (toggleHome)="toggleDashboardHome.emit($event)">
            </app-insights-library__dashboards>
          </ng-container>
        </div>
      </div>
      <div *ngIf="inViewMode" class="p-relative h-100p w-100p">
        @if (selectedVisual && page === 'insights') {
          <visual-embed [visualId]="selectedVisual.visual.id" [focused]="true"></visual-embed>
        }
        @else if (selectedDashboard && page === 'dashboards') {
          <div class="view-dashboard">
            <side-panel width="223" class="mr-15" [collapsible]="true">
              <side-panel-filter-list #filterList
                                      [mode]="SidePanelFilterListMode.View"
                                      [canEdit]="false"
                                      [canModifyFilters]="true"
                                      [dataModel]="dataModel()"
                                      [visualInteractions]="visualInteractions"
                                      [(filters)]="filters"
                                      (filtersChange)="onFiltersChanged()"></side-panel-filter-list>
              <div sidePanelCollapsed>
                <span class="side-panel-vertical-text user-select-none p-absolute ot-20 mt-10">
                  Filters ({{filterList.filters().length}})
                </span>
              </div>
            </side-panel>
            <div class="view-dashboard-right">
              <dashboard-embed [dashboardId]="selectedDashboard.dashboard.id"
                               [visualInteractions]="visualInteractions"
                               #dashboardEmbed></dashboard-embed>
            </div>
          </div>
        }
      </div>
    </ng-container>

    <trg-saving-overlay *ngIf="saving"></trg-saving-overlay>
  </div>
</div>
